/*
Document   : api/ecommerce/myProductApi
Created on : Sun 15 Feb 2026 19∶02∶15
Author     : Manasseh Achirka
*/

import { createApi } from '@reduxjs/toolkit/query/react';
import customHeaderFetchBase from '../customHeaderFetchBase';
import appConfig from 'appconfig';

const apiUrl = appConfig.thiapiBaseUrl + appConfig.modules.ecomm;
const multipartHeader = { headers: { 'Content-Type': 'multipart/form-data' } };
const jsonHeader = { headers: { 'Content-Type': 'application/json' } };

export const myProductApi = createApi({
  reducerPath: 'myProductApi',
  baseQuery: customHeaderFetchBase,
  tagTypes: ['MyProduct'],
  endpoints: (builder) => ({
    getMyProducts: builder.query({
      query: () => ({
        url: apiUrl + '/myproduct/',
        jsonHeader
      }),
      providesTags: ['MyProduct']
    }),
    addMyProduct: builder.mutation({
      query: (formData) => ({
        url: apiUrl + '/myproduct/',
        method: 'POST',
        body: formData,
        multipartHeader
      }),
      invalidatesTags: ['MyProduct']
    }),
    updateMyProduct: builder.mutation({
      query: (formData) => ({
        url: apiUrl + `/myproduct/${formData.get('id')}/`,
        method: 'PATCH',
        body: formData,
        multipartHeader
      }),
      invalidatesTags: ['MyProduct']
    }),
    updateMyProductSortOrder: builder.mutation({
      query: (formData) => ({
        url: appConfig.thiapiBaseUrl + appConfig.modules.tims + '/sortorder/',
        method: 'PATCH',
        body: formData,
        jsonHeader
      }),
      invalidatesTags: ['MyProduct']
    }),
    deleteMyProduct: builder.mutation({
      query: (id) => ({
        url: apiUrl + `/myproduct/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['MyProduct']
    })
  })
});

export const {
  useGetMyProductsQuery,
  useAddMyProductMutation,
  useUpdateMyProductMutation,
  useUpdateMyProductSortOrderMutation,
  useDeleteMyProductMutation
} = myProductApi;
